import React, { useEffect, useState } from 'react';
// import { Container, Typography, FormControl, InputLabel, Input, Box, FormGroup, Button } from '@material-ui/core';
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {serviceGetarea, serviceAddarea} from  "../Services/Service";

const initialValue = {
    areaName:"",
    btnValue: "",
    action:"",
    updateId:"",
    areaId:""
}

const AreaAdd = () => {

    const [formData, setFormData] = useState(initialValue);
    const {areaName,action } = formData;

    const [isvalid, setIsvalid] = useState(true);
    
    const [formErrors, setFormErrors] = useState('');
    const [headTitle, setHeadTitle] = useState([]);

    const navigate = useNavigate();
    const { id } = useParams();
    
    const [alertInfo, setAlertInfo] = useState({
        visible : false,
        cls : '',
        msg :''
      });
    const onShowAlert = (msg,visible,clas)=>{
        setAlertInfo({...alertInfo, ['visible']: visible,['cls']:clas,['msg']: msg});
    }

    useEffect(() => {
        // fetchAreaClinicDr();
        if(id != '' && id !== undefined){
            setHeadTitle('Update Division');
            loadUserData();
        }else{
            setHeadTitle('Add Division');
             setFormData({...formData, ['btnValue']: 'Submit',['action']: 'add'});
        }
        
    },[]);

    const loadUserData = async () =>{
        
        const response = await serviceGetarea(id);
        setFormData({...formData, ['btnValue']: 'Update',['action']: 'update',['updateId']: id,['areaName']: response.data.data.area[0].areaName});
        // onShowAlert();
    }

    const onValueChange = (e) =>
    {
        setFormData({...formData, [e.target.name]: e.target.value});
    }

    
    function validateForm(){
        
        if(isvalid){
            setIsvalid(true);
            setFormErrors('');
        }   
        return isvalid;   
    }
    const submitHandle = e => {
        e.preventDefault();
        
        let isvalidForm = validateForm();
        if(isvalidForm && isvalid){
            
            serviceAddarea(formData)
                .then((response) => {
  
                    if(typeof(response)!=='undefined'){
                        let clas = (response.data.status == "1") ? 'success' : 'danger';
                        if(response.data.status == "1" && formData.action=='add'){
                            setFormData({...formData, ['areaName']: ''});
                        }
                        onShowAlert(response.data.data.message,true,clas);    
                    }
                })
        }else{
            console.log('isvalid false');
        }
             
    }

    return (
        <>
            <section className='projects-section'>
            <div className='row'>
                <h1 className='title mb-4'>{headTitle}</h1>
                {alertInfo.visible ? <div className={"alert alert-"+ alertInfo.cls +" col-md-4 mb-2"} role="alert">{alertInfo.msg}</div> : null}

                {formErrors!='' ? <div className={"alert alert-danger col-md-4"} role="alert">{formErrors}</div> : null}
                

                <form onSubmit={submitHandle} className=''>
                
                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example1" className="form-control" required name="areaName" value={areaName} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Division Name</label>
                    </div>
                </div>

                
                <div className="clearfix"></div>
                <div className="col-md-6 mt-3">
                    <button type="submit" className="btn btn-primary btn-login mb-4" name="btnValue">{formData.btnValue}</button>
                </div>
                    
                </form>
                </div>

</section>

        </>
    )
}


export default AreaAdd;